import {
  useIsInsurerAdministrator,
  useRequirePermissions,
} from '@/shared/hooks';
import { FileSpreadsheet, Package, ScrollText, Users } from 'lucide-react';
import { Fragment } from 'react';
import { SettingsNavItem } from './settings-nav-item.component';
import { SettingsNavSubItem } from './settings-nav-sub-item.component';

export function SettingsSidebar() {
  // A rota de auditoria é exclusiva do Administrador (gate por grupo, igual ao
  // do BFF). Esconder o item evita levar os demais perfis para um redirect.
  const { isInsurerAdministrator } = useIsInsurerAdministrator();
  // `identity.users.read` só existe nos perfis Administrador e CX Atendimento da seguradora.
  const { hasPermission: canSeeReports } = useRequirePermissions({
    permissions: ['identity.users.read'],
  });

  const navItems = [
    {
      id: 'users',
      to: '/settings/users',
      icon: Users,
      label: 'Usuários',
      description: 'Gerencie usuários e suas contas',
    },
    {
      id: 'products',
      to: '/settings/products',
      icon: Package,
      label: 'Produtos',
      description: 'Modo de emissão e formas de pagamento',
      subItems: [
        { to: '/settings/products', label: 'Modo de emissão', exact: true },
        // Formas de pagamento é exclusiva do Administrador (gate por grupo no BFF).
        ...(isInsurerAdministrator === true
          ? [
              {
                to: '/settings/products/payment-methods',
                label: 'Formas de pagamento',
              },
            ]
          : []),
      ],
    },
    ...(canSeeReports === true
      ? [
          {
            id: 'reports',
            to: '/settings/reports',
            icon: FileSpreadsheet,
            label: 'Relatórios',
            description: 'Extraia o relatório de usuários da plataforma',
          },
        ]
      : []),
    ...(isInsurerAdministrator === true
      ? [
          {
            id: 'audit',
            to: '/settings/audit',
            icon: ScrollText,
            label: 'Auditoria',
            description: 'Veja quem fez o que e quando',
          },
        ]
      : []),
    // More sections will be added here later
  ];

  return (
    <div className='bg-alba-white-500 rounded-3xl shadow-[0px_4px_24px_0px_rgba(15,22,30,0.08)] p-[15px] w-full flex flex-col lg:w-[252px] lg:shrink-0 lg:h-full'>
      {/* Abaixo de lg os itens DIVIDEM a largura e quebram linha se
          precisarem. Com scroll horizontal, o último item ficava encostado
          na borda e parecia cortado — e ninguém descobre que a faixa rola. */}
      <nav className='flex flex-row flex-wrap gap-2 lg:flex-col lg:flex-nowrap lg:gap-[3.5px] lg:flex-1'>
        {navItems.map(item => (
          <Fragment key={item.id}>
            <SettingsNavItem
              to={item.to}
              icon={item.icon}
              label={item.label}
              description={item.description}
            />
            {'subItems' in item &&
              item.subItems?.map(subItem => (
                <SettingsNavSubItem
                  key={subItem.to}
                  to={subItem.to}
                  label={subItem.label}
                  exact={'exact' in subItem ? subItem.exact : false}
                />
              ))}
          </Fragment>
        ))}
      </nav>
    </div>
  );
}
